// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AdminBalancesClient = registerClientReference(
    function() { throw new Error("Attempted to call AdminBalancesClient() from the server but AdminBalancesClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(admin)/admin/balances/admin-balances-client.tsx",
    "AdminBalancesClient",
);
